import { Payment, AccountBalance } from '@mui/icons-material';
import { Button } from '@mui/material';
import React, { FC } from 'react';

interface IProps {
	children: React.ReactNode;
	icon: 'Card' | 'Bank';
	onClick?: () => void;
	type?: 'submit';
	disabled?: boolean;
}

const PaymentButton: FC<IProps> = ({ onClick, children, type, disabled, icon }) => {
	return (
		<Button
			startIcon={icon === 'Card' ? <Payment /> : <AccountBalance />}
			variant='contained'
			size='large'
			type={type}
			color='secondary'
			onClick={onClick}
			disabled={disabled}
			sx={(theme) => ({
				height: '48px',
				width: '100%',
				whiteSpace: 'nowrap',
				float: 'right',
				minWidth: '200px',
				maxWidth: '200px',
				[theme.breakpoints.down('md')]: {
					minWidth: 'initial',
					maxWidth: 'unset',
				},
			})}
		>
			{children}
		</Button>
	);
};

export default PaymentButton;
